export enum UserPartnerType {
  READY_FOR_ONBOARDING = 'READY_FOR_ONBOARDING', //Prospect
  ONBOARDED = 'ONBOARDED', //Partner
  DUPLICATE = 'DUPLICATE',
  WITHDRAWN = 'WITHDRAWN',
  REJECTED = 'REJECTED',
  ANONYMIZED = 'MEANONYMIZEDETING',
  //These are for v2 multiple read partner details
  ACTIVE = 'ACTIVE', //Partner
  DRAFT = 'DRAFT', //Prospect
}
